import { ServersService } from './../services/servers.service';
import { environment } from './../../environments/environment';
import { PaymentsService } from './../services/payments.service';
import { SpinnerModule } from 'angular2-spinner/dist';
import { SlimLoadingBarService } from 'ng2-slim-loading-bar';
import { NotificationsService } from 'angular2-notifications';
import { MessagesService } from './../services/messages.service';
import { BreadcrumbService } from 'ng2-breadcrumb/ng2-breadcrumb';
import { Router, Event as RouterEvent, NavigationEnd } from '@angular/router';
import { Response } from '@angular/http';
import { User } from './../interfaces/user.model';
import { ApiService } from './../services/api.service';
import { Component, OnInit} from '@angular/core';
import { MaintanceService } from '../services/maintance.service';

@Component({
  selector: 'app-main',
  templateUrl: './cocpit.component.html'
})
export class CocpitComponent implements OnInit {
  invoiceStorageURL = `${environment.api_url}`;
 
  user;
  subscriber: any;

  paymentsLoading: Boolean = true;
  maintanceMessageLoading: Boolean = true;

  paymentsList = <any>{};

  maintanceMessages = <any>{};

  serversList = <any>{};

  constructor(
    private apiService: ApiService,
    private router: Router,
    private breadcrumbService: BreadcrumbService,
    private messagesService: MessagesService,
    private notificationsService: NotificationsService,
    private slimLoadingBarService: SlimLoadingBarService,
    private paymentsService: PaymentsService, 
    private serversService: ServersService,
    private maintanceService: MaintanceService
    ) {}

  ngOnInit() {
    this.serversService.getAllCompanyServersDashboard().subscribe(
      (servers) => {
        this.serversList = servers;
      },
      (error) => {
        // console.log(error);
      }
    )

    this.maintanceService.getMaintance().subscribe(
      (messages) => {
        this.maintanceMessages = messages;
        this.maintanceMessageLoading = false;
      },
      (error) => {
        this.notificationsService.error('Ups', 'Błąd przy pobieraniu komunikatów serwisowych')
      }
    )

    this.paymentsService.getPayable('').subscribe(
      (payments) => {
        if(payments === false){
          this.notificationsService.error('Ups', 'Błąd przy pobieraniu listy płatności');  
        }
        this.paymentsLoading = false;
        this.paymentsList = payments;
      },
      (error) => {
        this.notificationsService.error('Ups', 'Błąd przy pobieraniu listy płatności');
      }
    )
  }

  buyServices (server){
    this.router.navigateByUrl('/service/offer?for_service=' + server.service);
  }

  payProforma (accessToken) {
    this.paymentsService.payProforma(accessToken).subscribe(
      (payment) => {
        // console.log(payment)
        location.href = String(payment);

        // console.log(payment);
      },
      (error) => {
        // console.log(error);
        this.notificationsService.error('Ups', 'Błąd przy wykonywaniu płatności PayU');
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/cocpit/cocpit.component.ts